export default __webpack_public_path__ + "static/media/imgIcon.8b5d552a.png";